import { BackgroundJobListPage } from "@/features/background-job/pages/BackgroundJobListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/background-job/")({
	component: BackgroundJobListPage,
});
